import { getAssetPath } from "@stencil/core";

export default class MapFullscreenControl implements mapboxgl.IControl {
	private container: HTMLDivElement;
	satelliteViewActivated = false;
	icon: HTMLImageElement;
	toggleButton: HTMLButtonElement;
	isFullscreen = false;

	// create a DOM element for the control
	createFullscreenToggleElement() {
		this.toggleButton = document.createElement("button");
		this.toggleButton.type = "button";
		this.toggleButton.title = "Toggle fullscreen mode.";
		this.toggleButton.id = "mapboxgl-ctrl-fullscreen-toggle";

		this.icon = document.createElement("img");
		this.icon.src = getAssetPath("assets/icon-map-fullscreen.png");
		this.icon.alt = "Map view icon";
		this.icon.classList.add("mapboxgl-ctrl-icon-modified");
		this.icon.width = 20;
		this.icon.height = 20;
		this.toggleButton.appendChild(this.icon);

		this.toggleButton.addEventListener("click", () => {
			// get root element of the sitenna-site-navigator component
			const rootElement = document.querySelector("sitenna-site-navigator");

			if (this.isFullscreen) {
				document.exitFullscreen();
				this.isFullscreen = !this.isFullscreen;
				this.container.classList.remove("active");
			} else {
				rootElement.requestFullscreen();
				this.isFullscreen = !this.isFullscreen;
				this.container.classList.add("active");
			}
		});

		return this.toggleButton;
	}

	onAdd() {
		this.container = document.createElement("div");
		this.container.className =
			"mapboxgl-ctrl mapboxgl-ctrl-fullscreen mapboxgl-ctrl-group";
		this.container.appendChild(this.createFullscreenToggleElement());
		return this.container;
	}

	onRemove() {
		this.container.parentNode.removeChild(this.container);
	}
}
